import { useUser } from 'hooks/useUser';
import { PartnerFinances } from 'types/state';

export const useUserPartnerFinances = (): null | PartnerFinances => {
  const user = useUser();

  if (user?.partnerFinances) {
    return user.partnerFinances;
  }

  return null;
};
